import { SERVER_URI } from '../Constant/server';
import { apiPost, apiGet, apiPut } from '../utils/axios';

const NewTaxRate = SERVER_URI + '/tax-rate';
const bindTaxRate = SERVER_URI + '/get-tax-rate';
const updateTaxRateStatus = SERVER_URI + '/tax-rate-status/';
const updateTaxRate = SERVER_URI + '/tax-rate/';

export default {
    createTaxRate: async function (payload) {
        return apiPost(NewTaxRate, payload);
    },
    getTaxRate: async function (payload) {
        //console.log('payload', payload);
        return apiPost(bindTaxRate, payload);
    },
    changeTaxStatus: async function (id) {
        return apiGet(updateTaxRateStatus + id);
    },
    updateTaxRate: async function (id, payload) {
       // console.log("id.....", id, payload)
        return apiPut(updateTaxRate + id, payload)
    }


};
